import { store } from "../../../store";
import Vehicle from "../../../classes/Vehicle";

export default {
  routes: [],

  dialogs: [
    {
      name: "vehicle-view",
      path: "/vehicles/:vehicleID/view",
      meta: {
        auth: () => Vehicle.canBeViewedBy(store.state.main.user),
      },
      component: () => import("../../../dialogs/employee/VehicleView"),
    },
  ],
};
